import { render, staticRenderFns } from "./WechatAppList.vue?vue&type=template&id=450ee47c&scoped=true&"
import script from "./WechatAppList.vue?vue&type=script&lang=js&"
export * from "./WechatAppList.vue?vue&type=script&lang=js&"
import style0 from "./WechatAppList.vue?vue&type=style&index=0&id=450ee47c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ee47c",
  null
  
)

export default component.exports